// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"BILvd__tooltipContainer","questionWrapper":"X1rLD__questionWrapper"};